export const performanceChartConfiguration = {
  seriesDefinitions: [
    {
      name: 'Current Temperature',
      color: '#4A5578',
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
    },
    {
      name: 'Lower Bounds',
      color: '#0086C9',
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
    },
    // {name: "Target", color: "#16B364", type: "spline", opacity: 1, yAxis: 0, dataGrouping: { approximation: "high"}},
    {
      name: 'Upper Bounds',
      color: '#E62E05',
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
    },
    {
      name: 'Outside Temperature',
      color: '#EAAA08',
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
    },
  ],

  plotBandColors: {
    C: '#D1E9FF',
    H: '#FEE4E2',
    F: '#EAECF0',
  },

  defaultLiveZoom: 3,
};
